import {postUrlencodedData, api} from '../request';

export function login(userName, passWord, callBack){
    postUrlencodedData(api.login, {userName: userName, passWord: passWord})
        .then(res => {
            if (res.code === 200)
                callBack(true);
            else
                callBack(false, res.message);
        }, rej => {
            console.log(rej);
            callBack(false)
        });
}
